// Partners Slider
const partnersSlider = document.querySelectorAll('[data-slider="partners-slider"]');

const partnersSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 12,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    992: {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 34,
      speed: 800,
    },
    1199: {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 48,
      speed: 800,
    },
    1439: {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 64,
      speed: 800,
    },
  },
};

partnersSlider.forEach((el) => new Swiper(el, partnersSliderOptions));
